/* CAKEWISH Holiday Homepage 2026 */
(function () {
  function initCarousel(car) {
    if (car.dataset.cwhReady) return;
    car.dataset.cwhReady = '1';
    var track = car.querySelector('[data-cwh-track]');
    var prev = car.querySelector('[data-cwh-prev]');
    var next = car.querySelector('[data-cwh-next]');
    if (!track) return;
    function update() {
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      if (prev) prev.classList.toggle('is-end', atStart);
      if (next) next.classList.toggle('is-end', atEnd);
    }
    function go(d) { track.scrollBy({ left: d * track.clientWidth * 0.85, behavior: 'smooth' }); }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    car._cwhUpdate = update;
  }

  function init(root) {
    root.querySelectorAll('[data-cwh-car]').forEach(initCarousel);

    // Just In / Bestsellers tabs
    var jtabs = root.querySelectorAll('[data-cwh-jtab]');
    var jlink = root.querySelector('[data-cwh-jlink]');
    jtabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-cwh-jtab');
        jtabs.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-sel', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        root.querySelectorAll('[data-cwh-jpanel]').forEach(function (p) {
          var on = p.getAttribute('data-cwh-jpanel') === id;
          p.hidden = !on;
          if (on) {
            var t = p.querySelector('[data-cwh-track]');
            if (t) t.scrollLeft = 0;
            var c = p.querySelector('[data-cwh-car]');
            if (c && c._cwhUpdate) c._cwhUpdate();
          }
        });
        if (jlink) {
          jlink.href = btn.getAttribute('data-url');
          var dt = jlink.querySelector('.cwh-dt');
          if (dt) dt.textContent = btn.getAttribute('data-label');
        }
      });
    });

    // Gift tags
    var gwrap = root.querySelector('[data-cwh-gifts]');
    if (gwrap) {
      var gtabs = gwrap.querySelectorAll('[data-cwh-gtab]');
      function pick(id, focusPanel) {
        gtabs.forEach(function (b) {
          var on = b.getAttribute('data-cwh-gtab') === id;
          b.classList.toggle('is-sel', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        gwrap.querySelectorAll('[data-cwh-gpanel]').forEach(function (p) {
          var on = p.getAttribute('data-cwh-gpanel') === id;
          p.hidden = !on;
          if (on) {
            var g = p.querySelector('.cwh-gpanel__grid');
            if (g) g.scrollLeft = 0;
            if (focusPanel && window.innerWidth < 768) {
              var tag = gwrap.querySelector('[data-cwh-gtab="' + id + '"]');
              if (tag) tag.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            }
          }
        });
      }
      gtabs.forEach(function (b) {
        b.addEventListener('click', function () { pick(b.getAttribute('data-cwh-gtab')); });
      });
      gwrap.querySelectorAll('[data-cwh-gnext]').forEach(function (b) {
        b.addEventListener('click', function () { pick(b.getAttribute('data-cwh-gnext'), true); });
      });
    }

    // Swipe nudge on mobile, once each row scrolls into view
    if ('IntersectionObserver' in window && window.matchMedia('(max-width: 767px)').matches &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('cwh-nudge'); io.unobserve(e.target); }
        });
      }, { threshold: 0.6 });
      root.querySelectorAll('.cwh-track, .cwh-cats__grid, .cwh-outer__grid, .cwh-acc__grid').forEach(function (el) { io.observe(el); });
    }
  }

  function boot() { document.querySelectorAll('[data-cwh]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
